import ValidateModule from "../ValidateModule";

import type { IEventChannel } from "@esWebAPI/es/model/Models";
import type AjaxRequestBroker from "@esWebAPI/es/AjaxRequestBroker";
import type {ApiOpts} from "@esWebAPI/es/model/Models";
import type CacheModule from "../CacheModule";

const es = global.es;

// Entitlement types // TODO: this is duplicated on SecurityModule.ts...
const Entitlements = {
    WORKSPACE: "workspace",
    GEOMAP: 'geomap',
    LAYER_META: 'layermeta',
    LAYER_VIEW: 'layerview',
    GEOMAP_TEMPLATE: 'geomap_template'
};

/**
 * @class SecurityEntitlementsModule
 */
export default class SecurityEntitlementsModule {
    private eventChannel: IEventChannel;
    private rqBroker: AjaxRequestBroker;
    private resourceName: string;
    private cache: CacheModule;

    /**
     * 
     * @param eventChannel 
     * @param rqBroker 
     * @param resourceName 
     * @param cache 
     */
    constructor(eventChannel: IEventChannel, rqBroker: AjaxRequestBroker, resourceName: string, cache: CacheModule) {
        this.eventChannel = eventChannel;
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;
        this.cache = cache;

        this.updateEntitlementsGeoMap = this.updateEntitlementsGeoMap.bind(this);
        this.updateEntitlementsLayerMeta = this.updateEntitlementsLayerMeta.bind(this);
        this.updateEntitlementsWorkspace = this.updateEntitlementsWorkspace.bind(this);
        this.updateEntitlementsGeoMapTemplate = this.updateEntitlementsGeoMapTemplate.bind(this);
        this.updateEntitlements = this.updateEntitlements.bind(this);
        //this.updateBulkEntitlements = this.updateBulkEntitlements.bind(this);
    }
    
    /**
     * update the entitlements
     * 
     * @param entitlements list with entitlements
     * @param id geoMap id
     * @param emailNotify boolean specifying if email should be sent
     * @param opts
     * 
     * @returns a jquery deferred object resolved when tenant is updated.
     */
    updateEntitlementsGeoMap(entitlements: object[], id: number, emailNotify?: boolean, opts?: ApiOpts) {
        return this.updateEntitlements(Entitlements.GEOMAP, entitlements, id, emailNotify, opts);
    }

    /**
     * update the entitlements
     * 
     * @param entitlements list with entitlements
     * @param id layerMeta id
     * @param emailNotify boolean specifying if email should be sent
     * @param opts
     * 
     * @returns a jquery deferred object resolved when tenant is updated.
     */
    updateEntitlementsLayerMeta(entitlements: object[], id: number, emailNotify?: boolean, opts?: ApiOpts) {
        return this.updateEntitlements(Entitlements.LAYER_META, entitlements, id, emailNotify, opts);
    }

    /**
     * update workspace entitlements
     *
     * @param entitlements actual state of entitlements
     * @param workspaceId workspace id to change entitlements of
     * @param emailNotify boolean specifying if email should be sent
     * @param opts
     * 
     * @returns
     */
    updateEntitlementsWorkspace(entitlements: object[], workspaceId: number, emailNotify?: boolean, opts?: ApiOpts) {
        //I don't know if this is best way to avoid possible missuse of the function
        //all functions start with same name, just suffix is different, easy to use workspace instead of geomap ...
        return this.updateEntitlements(Entitlements.WORKSPACE, entitlements, workspaceId, emailNotify, opts);
    }

    /**
     * update the entitlements
     * 
     * @param entitlements list with entitlements
     * @param id geoMapTemplate id
     * @param emailNotify boolean specifying if email should be sent
     * @param opts
     * 
     * @returns a jquery deferred object resolved when tenant is updated.
     */
    updateEntitlementsGeoMapTemplate(entitlements: object[], id: number, emailNotify?: boolean, opts?: ApiOpts) {
        return this.updateEntitlements(Entitlements.GEOMAP_TEMPLATE, entitlements, id, emailNotify, opts);
    }

    /**
     * update the entitlements
     * 
     * @param modelType type of entity to manage (Workspace, GeoMap, LayerView or LayerMeta)
     * @param entitlements list with entitlements
     * @param id entitlment id
     * @param emailNotify boolean specifying if email should be sent
     * @param opts
     * 
     * @returns a jquery deferred object resolved when tenant is updated.
     */
    private updateEntitlements(modelType: string, entitlements: object[], id: number, emailNotify?: boolean, opts?: ApiOpts) {
        if (!ValidateModule.checkMandatoryArg(entitlements) ||
            !ValidateModule.checkId(id)) {
            return es.util.deferred.rejected();
        }
        
        let url = es.api.getURL(this.resourceName) + '/' + modelType + '/' + id;
        if (emailNotify) {
            url = url + '?emailNotify=true';
        }
        
        return this.rqBroker.doPost({
            url: url,
            opts: opts,
            data: entitlements
        }).done((rs) => {
            // TODO: cache
            // this.cache.set(_cache, es.api.getURL(resourceName) + "/" + rs.id, rs);
            // this.cache.setEntity(resourceName, rs);
            this.cache.clear("Security");
            this.eventChannel.fireEvent("onUpdateEntitlements", modelType, id);
            // this.eventChannel.fireEvent("onUpdateEntitlements", rs);
        });
    }
//
//    /**
//     * Update entitlements. All used entityIds must be specified in ids. All entities to delete
//     * all entitlements must be specified in ids too but without any entitlement in entitlements.
//     *
//     * @param modelType
//     * @param entitlements
//     * @param ids
//     * @param opts
//     * @returns
//     */
//    private updateBulkEntitlements(modelType: string, entitlements: object[], ids: number[], opts?: any) {
//        if (!ValidateModule.checkMandatoryArg(entitlements) ||
//            !ValidateModule.checkIds(ids)) {
//            return es.util.deferred.rejected();
//        }
//        
//        return this.rqBroker.doPost({
//            url: es.api.getURL(this.resourceName) + '/bulk/' + modelType,
//            opts: opts,
//            data: {"entitlements": entitlements, "entityIds": ids}
//        }).done((rs) => {
//            // TODO: cache
//            // cache.set(_cache, es.api.getURL(resourceName) + "/" + rs.id, rs);
//            // cache.setEntity(resourceName, rs);
//            this.cache.clear("Security");
//            ids.forEach((id) => this.eventChannel.fireEvent("onUpdateEntitlements", modelType, id));
//            // this.eventChannel.fireEvent("onUpdateEntitlements", rs);
//        });
//    }
}
